import { Component } from 'react';
import { Input, Col, Row } from 'antd';
import request from '@src/util/request';
import { SyncOutlined } from '@ant-design/icons';
import { getLang } from '@src/packages/pro-table/component/util';

class Captcha extends Component<
  {
    onChange: (val?: any) => void;
  },
  {
    captchaText: any;
    loading?: boolean;
    captchaId: any;
    captcha: any;
    locale: string;
  }
> {
  constructor(props: any) {
    super(props);
    this.state = {
      captchaText: '',
      captchaId: '',
      captcha: null,
      locale: getLang()?.split('-')[0] || 'vi',
    };
    this.loadCaptcha();
  }

  async loadCaptcha() {
    const captInfo: any = await request({
      url: '/user/create-captcha',
    });
    console.log(`captchaInfo`, captInfo);
    this.setState({
      loading: false,
      captchaId: captInfo.data.tokenCapcha,
      captcha: captInfo.data.data,
    });
    this.onChange(this.state.captchaId, this.state.captchaText);
  }

  onChange(id: any, text: any) {
    let rs = null;
    if (id && text) {
      rs = `${id},${text}`;
    }
    if (this.props.onChange) {
      this.props.onChange(rs);
    }
  }

  render() {
    if (!this.state.captcha)
      return (
        <p>
          {this.state.locale === 'vi'
            ? 'Đang tải...'
            : this.state.locale === 'la'
            ? 'ກຳລັງດາວໂຫລດ...'
            : 'Loading...'}
        </p>
      );
    return (
      <Row>
        <Col xs={12}>
          <div
            className='captcha'
            dangerouslySetInnerHTML={{ __html: this.state.captcha }}
          ></div>
          <div className='captcha'>
            <Input
              type='text'
              placeholder={
                this.state.locale === 'vi'
                  ? 'Nhập mã captcha'
                  : this.state.locale === 'la'
                  ? 'ໃສ່ລະຫັດ captcha'
                  : 'Enter the captcha code'
              }
              value={this.state.captchaText}
              onChange={(evt) => {
                this.setState({ captchaText: evt.target.value });
                this.onChange(this.state.captchaId, evt.target.value);
              }}
              addonAfter={
                <SyncOutlined
                  onClick={() => {
                    this.loadCaptcha();
                  }}
                />
              }
            />
          </div>
        </Col>
      </Row>
    );
  }
}

export default Captcha;
